import { ref, readonly } from 'vue';

const STORAGE_KEY = 'lowVisionMode';
const ROOT_CLASS = 'a11y-low-vision';

const lowVisionModeState = ref(false);

function getRootElement() {
  if (typeof document === 'undefined') return null;
  return document.documentElement;
}

function normalizeLowVisionMode(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

export function readLowVisionMode() {
  if (typeof localStorage === 'undefined') return false;

  try {
    return normalizeLowVisionMode(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

export function applyLowVisionMode(enabled) {
  const normalized = normalizeLowVisionMode(enabled);
  lowVisionModeState.value = normalized;

  const root = getRootElement();
  if (!root) return normalized;

  root.classList.toggle(ROOT_CLASS, normalized);
  root.setAttribute('data-low-vision', normalized ? 'true' : 'false');

  return normalized;
}

export function setLowVisionMode(enabled) {
  const normalized = normalizeLowVisionMode(enabled);

  if (typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem(STORAGE_KEY, String(normalized));
    } catch {
      // ignore localStorage write errors
    }
  }

  return applyLowVisionMode(normalized);
}

export function initLowVisionMode() {
  const stored = readLowVisionMode();
  return applyLowVisionMode(stored);
}

export function useLowVisionMode() {
  return {
    isLowVisionEnabled: readonly(lowVisionModeState),
    initLowVisionMode,
    setLowVisionMode,
    applyLowVisionMode
  };
}
